module.exports = __webpack_public_path__ + "img/665.bcdce715.svg";